import * as React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import theme from '../theme';
import { Alert, Box, Checkbox, FormControlLabel, FormGroup, Snackbar } from '@mui/material';
import api from '../services/api';



export default function FormDialog(props) {
  const [handlerSnack, setHandlerSnack] = React.useState()
  
  const item = {
    cod_empresa: '',
    url: '',
    username: '',
    password: '',
    active: false,
    info: ''

  }
  const [state, setState] = React.useState(item);

  const handleChange = (event) => {
    setState({
      ...state,
      [event.target.name]: event.target.value,
    });
  };
  const handleChangeCheck = (event) => {

    setState({
      ...state,
      [event.target.name]:  event.target.checked
    });
  };

  React.useEffect(()=>{
    getEditInfo()
  },[props.open, handlerSnack])


  const getEditInfo = ()=>{
    setState(item)
    if(!props.id && !props.open) return
    api.get(`api_zabbix/find/${props.id}`)
    .then(res=>{
      setState(res.data.__data__)

    }).catch(err=> setState(item))
  }
  const showNotify = (msg,sev="success")=>{
    setMsgSnack(msg)
    setSevSnack(sev)
    setHandlerSnack(true)
  }
  
  const [ msgSnack, setMsgSnack ] = React.useState('')
  const [ sevSnack, setSevSnack ] = React.useState('')
  const handleSubmit = (event)=>{
    const handlerClose = ()=>{
      props.handlerClose()
    }
    event.preventDefault()
    if(!props.id){
      api.post('api_zabbix/create', state)
      .then(()=>{
          showNotify("Registro adicionado com sucesso.")
          handlerClose()
      }).catch(()=>{
          showNotify("Um erro ocorreu...",'error')
      })
    }else{
      api.put(`api_zabbix/edit/${props.id}/`, state)
      .then(()=>{
        showNotify("Registro editado com sucesso.")
        handlerClose()
    }).catch(()=>{
        handlerClose()
        showNotify("Um erro ocorreu...",'error')
    })
    }
  }

  return (
    <div>
      <Snack open={handlerSnack} message={msgSnack} severity={sevSnack} handlerSnack={()=>setHandlerSnack(false)}/>
      <Dialog open={props.open} fullWidth={true}
        maxWidth='sm'>
        <Box component="form" onSubmit={handleSubmit}  sx={{ mt: 1 }}>
        <DialogTitle>
            {!props.id ? 'Criar Api' : "Editar Api"}
        </DialogTitle>
        <DialogContent>
          <TextField
            required
            autoFocus
            margin="dense"
            id="cod_empresa"
            name="cod_empresa"
            label="Empresa"
            type="text"
            fullWidth
            value={state.cod_empresa}
            onChange={handleChange}
            variant="outlined"
            size="small"
          />        
          <TextField
          required
          size="small"
            margin="dense"
            id="url"
            name="url"
            label="Endereço APi"
            type="text"
            fullWidth
           value={state.url}
           onChange={handleChange}
            variant="outlined"
            />
          <TextField
          required
          size="small"
            
          margin="dense"
          id="username"
          name="username"
          label="Usuário da API"
          type="text"
          fullWidth
         value={state.username}
         onChange={handleChange}
          variant="outlined"
          />
          <TextField  
          required
            size="small"
            margin="dense"
            id="password"
            name="password"
            value={state.password}
            onChange={handleChange}
            label="Senha da API"
            type="text"
            fullWidth
            variant="outlined"
          />
          <TextField  
          required
            size="small"
            margin="dense"
            id="info"
            name="info"
            value={state.info}
            onChange={handleChange}
            label="Planilha com informações da empresa"
            type="text"
            fullWidth
            variant="outlined"
          />
          <FormGroup>

          <FormControlLabel sx={{ ml:1, mt:1}}
            control={
              <Checkbox checked={state.active} onChange={handleChangeCheck} name="active"
              />
            }
            label="Ativo"
            />
            </FormGroup>
          
        </DialogContent>
        <DialogActions>
          <Button sx={{color: theme.palette.text.primary}} onClick={props.handlerClose}>Cancelar</Button>
          <Button sx={{color: theme.palette.text.primary}} type='submit'> {!props.id ? 'Adicionar' : "Editar"}</Button>
        </DialogActions>
          </Box>
      </Dialog>
    </div>
  );
}

const Snack = (props)=>{
  return  (
    <Snackbar
    open={props.open}
    autoHideDuration={6000}
    onClose={() => {props.handlerSnack()}}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'center',
    }} 
    >
     <Alert  onClose={() => {props.handlerSnack()}} severity={props.severity ? props.severity : 'error'} sx={{ width: '100%' }}>
    {props.message}
  </Alert>
  </Snackbar>
  )
}